import React from "react"
import ReactDOM from "react-dom"
// 放到苍穹页面直接使用
import ModelTest from "../src/componets/index/index"
import {createStore} from "redux"
import {modelTestReducer} from "../src/componets/reducer/reducer"
import {Provider} from "react-redux"
import {
    classiferInit,
    classiferUpdateData,
    errorMessage,
    modelTestInit,
    modelTestUpdate,
} from "../src/componets/action/action"
import {isProduction} from "../src/function/checkProduct"
import {isEmpty} from "lodash"
;(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            this.passageway = new Date().getTime()
            this.store = createStore(modelTestReducer)
            if (!isEmpty(props.data)) {
                this.store.dispatch(classiferInit(props.data))
            }
            this.store.dispatch({type: "setModel", payload: this.model})
            this.model.invoke("init", "init")
            isProduction ? console.log("-----init", this.model.style, props) : null
            KDApi.loadFile("./main.css", this.model, () => {
                ReactDOM.render(
                    <Provider store={this.store}>
                        <ModelTest passageway={this.passageway} model={this.model} />
                    </Provider>,
                    this.model.dom
                )
            })
        },
        update: function (props) {
            isProduction ? console.log("-----update", this.model, props) : null
            if (props.data !== undefined) {
                if ("init" in props.data) {
                    this.store.dispatch(classiferInit(props.data.init))
                } else if ("modelTest" in props.data) {
                    this.store.dispatch(modelTestUpdate(props.data.modelTest))
                } else if ("errorMessage" in props.data) {
                    this.model.invoke("resultData", {
                        code: "0",
                        message: props.data.errorMessage,
                    })
                    this.store.dispatch(errorMessage(props.data.errorMessage))
                } else {
                    this.store.dispatch(classiferUpdateData(props.data))
                }
            }
        },
        destoryed: function () {
            isProduction ? console.log("-----destoryed", this.model) : null
        },
    }

    // 注册自定义组件
    KDApi.register("ai-cvp-ocr-classifier", MyComponent)
})(window.KDApi)

console.log("modeltest: <<<<<<<<<<<<<<<<<<<<<<<SS_TIME_STAMP>>>>>>>>>>>>>>>>>>>>>")
